module.exports = __webpack_public_path__ + "static/media/argumentDeveloper.eb3027dd.svg";